import React, { useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  Grid,
  GeoAlt,
  Truck,
  CameraVideo,
  Activity,
  BoxArrowInRight,
  CreditCard,
  Bell,
  Gear,
  Headset,
  ChevronRight
} from "react-bootstrap-icons";
import { BiLogOut } from "react-icons/bi";
import { AuthContext } from "../../states/AuthContext";
import { LuLock } from "react-icons/lu";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";


const Sidebar = ({ isOpen, closeSidebar }) => {

  const {setUserLoggedIn, setUserProfileData, userProfileData} = useContext(AuthContext);
  const navigate = useNavigate();

  const logoutHandler = () => {

    setUserLoggedIn(false);
    setUserProfileData(null);
    localStorage.removeItem("userLoggedIn");
    localStorage.removeItem("userAuthToken");
    localStorage.removeItem("userProfileData");
    navigate("/login", {  replace: true });
};

  return (
    <div className={`sidebar ${isOpen ? "open" : ""}`}>

      {/* CLOSE (mobile) */}
      <div className="close-btn d-md-none" onClick={closeSidebar}>✕</div>

      {/* LOGO */}
      <div className="sidebar-logo">
        TRUCKTUCK <span className="pro-badge">PRO</span>
      </div>

      {/* OPERATIONS */}
      <div className="menu-section">
        <div className="section-title green">OPERATIONS</div>

        <NavLink to="/" onClick={closeSidebar}
          className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>
          <Grid />
          <span>Fleet Overview</span>
        </NavLink>

        <NavLink to="/reserve-booking" onClick={closeSidebar}
          className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>
          <span className="icon-boxs">P</span>
          <span>Reserve Parking</span>
          {/* <ChevronRight className="arrow" /> */}
        </NavLink>

        <NavLink to="/location-pricing" onClick={closeSidebar}
          className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>
          <GeoAlt />
          <span>Network Locations</span>
          {/* <ChevronRight className="arrow" /> */}
        </NavLink>
      </div>

      {/* CONTROL */}
      <div className="menu-section">
        <div className="section-title blue">CONTROL</div>

        <NavLink to="/manage-vehicles-driver" onClick={closeSidebar}
          className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>
          👤 <span>Driver Control</span>
          {/* <ChevronRight className="arrow" /> */}
        </NavLink>

        <NavLink to="/manage-vehicles" onClick={closeSidebar}
          className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>
          <Truck />
          <span>Fleet Assets</span>
          {/* <ChevronRight className="arrow" /> */}
        </NavLink>

        <NavLink to="/access-control" onClick={closeSidebar}
          className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>
          <LuLock />
          <span>Access Control</span>
          {/* <ChevronRight className="arrow" /> */}
        </NavLink>
      </div>

      {/* MONITORING */}
      <div className="menu-section">
        <div className="section-title purple">MONITORING</div>

        <NavLink to="/live-camera" onClick={closeSidebar}
          className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>
          <CameraVideo />
          <span>Live Cameras</span>
          {/* <ChevronRight className="arrow" /> */}
        </NavLink>

        <NavLink to="/driver-activity" onClick={closeSidebar}
          className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>
          <Activity />
          <span>Driver Activity</span>
          {/* <ChevronRight className="arrow" /> */}
        </NavLink>

        <NavLink to="/entry-exit" onClick={closeSidebar}
          className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>
          <BoxArrowInRight />
          <span>Entry / Exit Logs</span>
          {/* <ChevronRight className="arrow" /> */}
        </NavLink>
      </div>

      {/* FINANCE */}
      <div className="menu-section mb-0">
        <div className="section-title orange">FINANCE</div>

        <NavLink to="/billing" onClick={closeSidebar}
          className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>
          <LiaFileInvoiceDollarSolid size={20} />
          <span>Usage & Billing</span>
          {/* <ChevronRight className="arrow" /> */}
        </NavLink>

        <NavLink to="/transactions" onClick={closeSidebar}
          className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>
          <CreditCard />
          <span>Payments</span>
          {/* <ChevronRight className="arrow" /> */}
        </NavLink>
      </div>

      <hr/>

      {/* BOTTOM */}
      <div className="menu-section">

        <NavLink to="/alert-preferences" onClick={closeSidebar}
          className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>
          <Bell />
          <span>Alerts / Notifications</span>
          {/* <span className="badge text-primary">5</span> */}
        </NavLink>

        {/* <NavLink to="/settings" className="menu-item">
          <Gear />
          <span>Settings</span>
        </NavLink> */}

        <NavLink to="/support" className={({ isActive }) => isActive ? "menu-item active" : "menu-item"} onClick={closeSidebar}>
          <Headset />
          <span>Support</span>
        </NavLink>

        <div
          className="menu-item"
          onClick={logoutHandler}
        >
          <BiLogOut color="red" /> Logout
        </div>
      </div>

      {/* USER */}
     {userProfileData &&  <div className="sidebar-user">
        <div className="avatar">AD</div>
        <div>
          <div className="name">{userProfileData?.userName}</div>
          <div className="email text-break small"><small>{userProfileData?.email}</small></div>
          <div className="role">Dispatcher</div>
        </div>
      </div>
}

    </div>
  );
};

export default Sidebar;